export enum GTM_STEP {
  SELECT,
  CONFIRM,
  VERIFY,
  LOADING,
}
